var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 144,
    viewBox: "0 0 144 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72 24C45.4903 24 24 45.4903 24 72C24 98.5097 45.4903 120 72 120C98.5097 120 120 98.5097 120 72C120 45.4903 98.5097 24 72 24ZM12 72C12 38.8629 38.8629 12 72 12C105.137 12 132 38.8629 132 72C132 105.137 105.137 132 72 132C38.8629 132 12 105.137 12 72ZM72 39C75.3137 39 78 41.6863 78 45V76.5C78 79.8137 75.3137 82.5 72 82.5C68.6863 82.5 66 79.8137 66 76.5V45C66 41.6863 68.6863 39 72 39ZM78.75 96.75C78.75 100.478 75.7279 103.5 72 103.5C68.2721 103.5 65.25 100.478 65.25 96.75C65.25 93.0221 68.2721 90 72 90C75.7279 90 78.75 93.0221 78.75 96.75Z",
    fill: "#A81708"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/error-icon.1d34031df14c9d3374b0d8b907cd73f7.svg";
export { ForwardRef as ReactComponent };